/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInheritance = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 14v8h-6v-2h4v-4h-4v-2zM10 2v8H7v7h4.585l-1.292-1.293 1.414-1.414L15.414 18l-3.707 3.707-1.414-1.414L11.585 19H5v-9H2V2zM8 4H4v4h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgInheritance as Inheritance };
